"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _flightsSearchBox = _interopRequireDefault(require("@tajawal/web-flights-sdk/lib/stores/flights-search-box.store"));
var _hotelChains = _interopRequireDefault(require("./hotel-chains.store"));
var _user = _interopRequireDefault(require("./user.store"));
var _interests = _interopRequireDefault(require("./interests.store"));
var _kycPrefrencesSave = _interopRequireDefault(require("./kyc-prefrences-save.store"));
var _kycPrefrencesGet = _interopRequireDefault(require("./kyc-prefrences-get.store"));
var _kycPrefrencesGetStatus = _interopRequireDefault(require("./kyc-prefrences-get-status.store"));
var _favouriteDestination = _interopRequireDefault(require("./favourite-destination.store"));
var _airlines = _interopRequireDefault(require("./airlines.store"));
var _cms = _interopRequireDefault(require("./cms.store"));
/**
 * kyc prefrences page store
 */
let KYCPrefrencesStore = /*#__PURE__*/(0, _createClass2.default)(
/**
 * constructor
 * @param {Object} initialState
 * @param {Object} $env
 */
function KYCPrefrencesStore(initialState = {}, $env) {
  (0, _classCallCheck2.default)(this, KYCPrefrencesStore);
  this.$env = $env;
  this.hotelChains = new _hotelChains.default(initialState.hotelChains);
  this.userStore = new _user.default(initialState.userStore);
  this.interests = new _interests.default(initialState.interests);
  this.saveKYCPrefrences = new _kycPrefrencesSave.default(initialState.saveKYCPrefrences);
  this.getKYCPrefrences = new _kycPrefrencesGet.default(initialState.getKYCPrefrences);
  this.getPrefrencesStatus = new _kycPrefrencesGetStatus.default(initialState.getPrefrencesStatus);
  this.flightSearchStore = {
    searchBoxStore: new _flightsSearchBox.default(initialState.flightSearchStore)
  };
  this.favoriteDestinations = new _favouriteDestination.default(initialState.favoriteDestinations);
  this.airlines = new _airlines.default(initialState.airlines);
  this.cmsStore = new _cms.default(initialState.userStore, this.$env);
});
exports.default = KYCPrefrencesStore;